<template>
  <v-app id="inspire">
    <v-main class="bg-secondary-light">
      <v-container fluid>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="10"
            md="12"
            align="center"
          >
            <template>
              <a href="/">
                <v-img
                  :src="'/storage/' + app.logo"
                  :lazy-src="'/storage/' + app.logo"
                  class="mb-0"
                  :max-width="app.logoWidth"
                  :max-height="app.logoHight"
                />
              </a>
            </template>
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      app: "configs/overall",
    }),
  },
};
</script>
